import {jwtDecode} from "jwt-decode";
import {AuthenticationResponse} from "./auth.models";
import {Claim} from "../Models";
import {getUserManager} from "../onelogin/OneLoginHelper"
import {useNavigate} from "react-router-dom";

export namespace JwtUtils {
    const tokenKey = 'token';
    const isImpersonatedByKey = 'is-impersonated-by';
    const expirationKey = 'token-expiration';
    const impersonatingUserTokenKey = 'i-token';
    const impersonatingUserExpirationKey = 'i-token-expiration';
    
    interface DecodedToken {
        [key: string]: any;

        exp?: number;
        ImpersonatedBy?: string;
    }

    export function impersonateUser(authData: AuthenticationResponse) {
        const currentToken = getToken();
        const currentExpirationKey = localStorage.getItem(expirationKey);
        saveToken(authData);
        localStorage.setItem(impersonatingUserTokenKey, currentToken!);
        localStorage.setItem(impersonatingUserExpirationKey, currentExpirationKey!);
    }

    export function saveToken(authData: AuthenticationResponse) {
        localStorage.setItem(tokenKey, authData.Token);
        localStorage.setItem(expirationKey, authData.Expiration.toString());

        if (authData.Token) {
            const dataToken: DecodedToken = jwtDecode(authData.Token);
            const impersonatedBy = dataToken.ImpersonatedBy;
            if (!impersonatedBy)
                localStorage.removeItem(isImpersonatedByKey);
            else
                localStorage.setItem(isImpersonatedByKey, impersonatedBy);
        }
    }

    export function isImpersonatedInfo(): { login: string, expiration: Date } | null {
        const userName = localStorage.getItem(isImpersonatedByKey);
        if (!userName)
            return null;

        const expiration = localStorage.getItem(expirationKey);
        return expiration
            ? {login: userName, expiration: new Date(expiration)}
            : null;
    }

    export function getClaims(): Claim[] {
        const token = localStorage.getItem(tokenKey);
        if (!token) return [];

        const expiration = localStorage.getItem(expirationKey);
        if (!expiration || new Date(expiration) <= new Date()) {
            logout(); // Token expired
            return [];
        }

        const dataToken: DecodedToken = jwtDecode(token);
        const response: Claim[] = [];

        for (const key in dataToken) {
            if (Object.prototype.hasOwnProperty.call(dataToken, key)) {
                response.push({name: key, value: dataToken[key]});
            }
        }

        return response;
    }

    export function getToken(): string | null {
        return localStorage.getItem(tokenKey);
    }

    /** returns true if redirection hs been done */
    export function logout(): Promise<boolean> {
        
        if (isImpersonatedInfo()) {
            const token = localStorage.getItem(impersonatingUserTokenKey);
            const expiration = localStorage.getItem(impersonatingUserExpirationKey);
            localStorage.removeItem(impersonatingUserTokenKey);
            localStorage.removeItem(impersonatingUserExpirationKey);

            if (token && expiration) {
                localStorage.setItem(tokenKey, token);
                localStorage.setItem(expirationKey, expiration);
            } else {
                localStorage.removeItem(tokenKey);
                localStorage.removeItem(expirationKey);
            }
            localStorage.removeItem(isImpersonatedByKey);
            return Promise.resolve(false);
        }

        localStorage.removeItem(tokenKey);
        localStorage.removeItem(expirationKey);
        localStorage.removeItem(isImpersonatedByKey);
        return getUserManager().removeUser().then(()=>{
            window.location.replace("/logout");
            return Promise.resolve(true);
        });

    }
}
